var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutSuccessfully(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_21998)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_21998",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 121
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.500008H120.5V120.5H0.5V0.500008Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_21998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.6517 24.0411C82.9611 26.1031 97.1912 41.6396 97.1912 60.5C97.1912 80.7641 80.7641 97.1912 60.5 97.1912C40.2359 97.1912 23.8086 80.7641 23.8086 60.5C23.8086 41.656 38.0143 26.1298 56.3007 24.0465",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2344 16.43C69.6335 19.0367 73.3213 20.0248 76.7024 18.9668C81.812 17.3679 87.197 20.4771 88.3673 25.7016C89.1414 29.1586 91.8412 31.8584 95.2982 32.6325C100.523 33.8028 103.632 39.1878 102.033 44.2974C100.975 47.6785 101.963 51.3664 104.57 53.7654C108.509 57.391 108.509 63.6089 104.57 67.2347C101.963 69.6338 100.975 73.3217 102.033 76.7028C103.632 81.8124 100.523 87.1974 95.2982 88.3674C91.8412 89.1418 89.1414 91.8415 88.3673 95.2985C87.197 100.523 81.812 103.632 76.7024 102.033C73.3213 100.975 69.6335 101.963 67.2344 104.57C63.6088 108.51 57.3906 108.51 53.7651 104.57C51.366 101.963 47.6781 100.975 44.297 102.033C39.1874 103.632 33.8024 100.523 32.6324 95.2985C31.8581 91.8415 29.1583 89.1418 25.7013 88.3674C20.4768 87.1974 17.3676 81.8124 18.9667 76.7028C20.0247 73.3217 19.0363 69.6338 16.4296 67.2347C12.4903 63.6089 12.4903 57.391 16.4296 53.7654C19.0363 51.3664 20.0247 47.6785 18.9667 44.2974C17.3676 39.1878 20.4768 33.8028 25.7013 32.6325C29.1583 31.8584 31.8581 29.1586 32.6324 25.7016C33.8024 20.4771 39.1874 17.3679 44.297 18.9668C47.6781 20.0248 51.366 19.0367 53.7651 16.43C57.3906 12.4903 63.6088 12.4903 67.2344 16.43Z",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.254 2.25788L103.551 16.9607",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.902 27.578L118.254 25.5725",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7769 9.60925L94.7824 2.25785",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74609 2.25788L17.4489 16.9607",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0975 27.578L2.74609 25.5725",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2228 9.60925L26.2173 2.25785",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.254 118.742L103.551 104.039",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.902 93.4221L118.254 95.4276",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7769 111.391L94.7824 118.742",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74609 118.742L17.4489 104.039",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0975 93.4221L2.74609 95.4276",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2228 111.391L26.2173 118.742",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3104 67.4311L83.7341 53.0074C85.1743 51.5672 85.1743 49.2324 83.7341 47.7921L79.201 43.2591C77.7608 41.8189 75.4257 41.8189 73.9855 43.2591L54.8705 62.374L47.3748 54.8782C45.9345 53.438 43.5995 53.438 42.1592 54.8782L37.2652 59.7724C35.825 61.2127 35.825 63.5478 37.2652 64.9878L49.8041 77.5268C52.4028 80.1253 56.6159 80.1253 59.2147 77.5268L63.5373 73.2042",
    stroke: "#4EAD4E",
    strokeWidth: 2.87109,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_21998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutSuccessfully);
export default __webpack_public_path__ + "static/media/checkout-successfully.ca44c6697177380f17e6ca7b0821c580.svg";
export { ForwardRef as ReactComponent };